import Disponibilidade from './Disponibilidade';

export default Disponibilidade;
